export const getFilterOption = (schedules) => {
  if (schedules?.length === 0) return null
  const operator = {
    enabledSearch: false,
    multiselection: false,
    placeholder: 'Operator',
    options: [
      {
        label: '= Equals',
        value: '= Equals'
      },
      {
        label: '≠ not Equals',
        value: '≠ not Equals'
      },
    ]
  }

  const property = {
    enabledSearch: true,
    placeholder: 'Property',
    options: [
      {
        label: 'Order Priorities',
        value: 'Order Priorities',
        operator: operator,
        properties: {
          enabledSearch: false,
          multiselection: true,
          placeholder: 'Value',
          options: [
            { label: 'Normal', value: 'Normal' },
            { label: 'High', value: 'High' },
            { label: 'ASAP', value: 'ASAP' }
          ]
        }

      },
      {
        label: 'Schedule Status',
        value: 'Schedule Status',
        operator: operator,
        properties: {
          enabledSearch: false,
          multiselection: true,
          placeholder: 'Value',
          options: [
            { label: 'Generating', value: 'Generating' },
            { label: 'Draft', value: 'Draft' },
            { label: 'Experimental', value: 'Experimental' },
            { label: 'Rejected', value: 'Rejected' },
            { label: 'Expired', value: 'Expired' },
            { label: 'Empty', value: 'Empty' }
          ]
        }
      }
    ]
  }
  return property
}

export const handleApplyFilters = (scheduleData, filters) => {
  let allSchedules = scheduleData;
  
  if (filters?.searchFilter) {
    const searchValue = filters.searchFilter.trim().toLowerCase();
    const updatedSchedules = allSchedules?.filter((schedule) =>
      schedule?.label?.toLowerCase().includes(searchValue));
    allSchedules = updatedSchedules;
  }

  if (filters?.advanceFilters) {
    filters?.advanceFilters.forEach((filter) => {
      const { value, operator, properties } = filter;
      const updatedValues = typeof value === 'string' ? [value] : value;
      
      if (properties === 'Order Priorities') {
        const updatedSchedules = [];
        allSchedules.forEach((schedule) => {
          const scheduleSummary = schedule.scheduleSummary || {};
          const schedulePriorities = [];

          // Check what priorities this schedule has
          if (scheduleSummary.normalOrderCount > 0) {
            schedulePriorities.push('Normal')
          } else if (scheduleSummary.highOrderCount > 0) {
            schedulePriorities.push('High')
          } else if (scheduleSummary.asapOrderCount > 0) {
            schedulePriorities.push('ASAP')
          }

          // Check if schedule has any of the selected priorities
          const hasSelectedPriority = updatedValues.every((value) => schedulePriorities.includes(value))

          if (operator === "= Equals" && hasSelectedPriority) {
            updatedSchedules.push(schedule)
          } else if (operator === "≠ not Equals" && !hasSelectedPriority) {
            updatedSchedules.push(schedule)
          }
        })
        allSchedules = updatedSchedules;
      } else if (properties === 'Schedule Status') {
        const updatedSchedules = [];
        allSchedules.forEach(schedule => {
          const hasSelectedStatus = updatedValues.includes(schedule.state)
          if (operator === '= Equals' && hasSelectedStatus) {
            updatedSchedules.push(schedule)
          } else if (operator === '≠ not Equals' && !hasSelectedStatus) {
            updatedSchedules.push(schedule)
          }
        })
        allSchedules = updatedSchedules;
      }
    })
  }

  return allSchedules
}
